<template>
  <div>
    <v-dialog
      v-model="getModalCadastroAtividadeCrmProposta"
      persistent
      max-width="720px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Registrar Atividade</v-card-title>
        <v-card-text>
          <v-form class="px-3 pt-3" ref="formAtividadeCrmProposta">
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadeCrmProposta.data_atividade"
                  label="Data"
                  outlined
                  dense
                  type="date"
                  class="ml-1 mr-1"
                  :rules="rules.data_atividade"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadeCrmProposta.hora_atividade"
                  label="Horário"
                  outlined
                  dense
                  type="time"
                  class="ml-1 mr-1"
                  :rules="rules.hora_atividade"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-select
                  :items="getCrmPropostaStatus"
                  v-model="status"
                  label="Status"
                  :rules="rules.status"
                  outlined 
                  dense
                  class="ml-1 mr-1"
                ></v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  v-model="getAtividadeCrmProposta.descricao"
                  label="Descrição"
                  outlined
                  dense
                  class="ml-1 mr-1"
                  :rules="rules.descricao"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            outlined
            dense
            @click="setModalCadastroAtividadeCrmProposta(false)"
            >Voltar</v-btn
          >
          <v-btn
            color="error"
            @click="setModalExcluirAtividadeCrmProposta(true)"
            outlined
            v-if="getAtividadeCrmProposta.id"
            >Excluir</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" outlined dense @click="salvar()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalExcluir />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalExcluir from "@/pages/crm/proposta/atividade/ModalExcluir";
export default {
  components: {
    ModalExcluir,
  },
  data() {
    return {
      rules: {
        data_atividade: [(v) => !!v || "Campo obrigatório."],
        hora_atividade: [(v) => !!v || "Campo obrigatório."],
        descricao: [(v) => !!v || "Campo obrigatório."],
        status: [(v) => !!v || "Campo obrigatório."],
      },
      status: "",
    };
  },
  computed: {
    ...mapGetters([
      "getModalCadastroAtividadeCrmProposta",
      "getFuncionarioCrmProposta",
      "getAtividadeCrmProposta",
      "getCrmProposta",
      "getCrmPropostaStatus"
    ]),
  },
  watch: {
    getModalCadastroAtividadeCrmProposta(){
      if(this.getModalCadastroAtividadeCrmProposta == false){
        this.status = ""
      }else{
        this.status = this.getCrmProposta.status
      }
    }
  },
  methods: {
    ...mapActions([
      "setModalCadastroAtividadeCrmProposta",
      "salvarAtividadeCrmProposta",
      "atualizarAtividadeCrmProposta",
      "setModalExcluirAtividadeCrmProposta",
    ]),
    salvar() {
      if (this.$refs.formAtividadeCrmProposta.validate() == false) {
        return;
      }

      this.getAtividadeCrmProposta.crm_proposta_id = this.getCrmProposta.id;
      this.getAtividadeCrmProposta.status = this.status
      if (this.getAtividadeCrmProposta.id) {
        this.atualizarAtividadeCrmProposta(this.getAtividadeCrmProposta);
      } else {
        this.salvarAtividadeCrmProposta(this.getAtividadeCrmProposta);
      }
    },
  },
};
</script>